export const AppConfig = {
  site_name: 'PostMage',
  title:
    'PostMage - Generate automatically eye-catching and colorful social share image',
  description:
    'Increase your organic social media reach with outstanding and eye-catching visuals. Automatically generate social image for websites and blogs with one line of code.',
  locale: 'en',
};
